import { useEffect, useRef, useState } from 'react';
import {  PUBLIC_KEY } from '../../../shared/constants';

export const useNewConektaCards = ({ isRender = true, instanceId }) => {
  const submitConektaPaymentRef = useRef(null);
  const promiseResolveRef = useRef(null);
  const promiseRejectRef = useRef(null);
  const [token, setToken] = useState('');
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isRender) {
      // Limpiar contenido del elemento cuando isRender es false
      const element = document.getElementById(instanceId);
      if (element) {
        element.innerHTML = '';
      }
      // Resetear referencias y estados
      submitConektaPaymentRef.current = null;
      promiseResolveRef.current = null;
      promiseRejectRef.current = null;
      setToken('');
      setHasError(false);
      setError(null);
      return;
    }

    // Verificar que el elemento existe en el DOM
    const element = document.getElementById(instanceId);
    if (!element) {
      return;
    }

    const options = {
      backgroundMode: 'lightMode',
      inputType: 'minimalMode',
      useExternalSubmit: true,
    };

    const config = {
      locale: 'es',
      publicKey: PUBLIC_KEY,
      targetIFrame: `#${instanceId}`,
      useExternalSubmit: true,
      colorPrimary: '#77BC1F',
    };

    const callbacks = {
      // Evento que permitirá saber que el token se creado de forma satisfactoria, es importante que se consuman los datos que de él derivan.
      onCreateTokenSucceeded: function(tokenData) {
        if (tokenData.id) {
          console.log('token', tokenData);
          setToken(tokenData.id);
          setHasError(false);
          setError(null);
          
          // Resolver la promesa pendiente
          if (promiseResolveRef.current) {
            promiseResolveRef.current({
              token: tokenData.id,
              hasError: false,
              error: null,
            });
            promiseResolveRef.current = null;
            promiseRejectRef.current = null;
          }
        }
      },
      // Evento que permitirá saber que el token se creado de manera incorrecta, es importante que se consuman los datos que de él derivan y se hagan las correciones pertinentes.
      onCreateTokenError: function(errorData) {
        console.log(errorData);
        setHasError(true);
        setError(errorData);
        setToken('');
        
        // Resolver la promesa pendiente con error
        if (promiseResolveRef.current) {
          promiseResolveRef.current({
            token: '',
            hasError: true,
            error: errorData,
          });
          promiseResolveRef.current = null;
          promiseRejectRef.current = null;
        }
      },
      // Evento que notifica cuando finalizó la carga del component/tokenizer
      onGetInfoSuccess: function(loadingTime) {
        console.log('loading time en milisegundos', loadingTime.initLoadTime);
      },

      onUpdateSubmitTrigger: function(submitFunction) {
        submitConektaPaymentRef.current = submitFunction;
        console.log('submitConektaPayment actualizado:', submitConektaPaymentRef.current);
      },
    };

    window.ConektaCheckoutComponents.Card({
      config,
      callbacks,
      //Este componente "allowTokenization" permite personalizar el tokenizador, por lo que su valor siempre será TRUE
      allowTokenization: true,
      options,
    });

    // Cleanup function para cuando el componente se desmonte o isRender cambie a false
    return () => {
      const cleanupElement = document.getElementById(instanceId);
      if (cleanupElement) {
        cleanupElement.innerHTML = '';
      }
      submitConektaPaymentRef.current = null;
      promiseResolveRef.current = null;
      promiseRejectRef.current = null;
    };
  }, [isRender]);

  const requestCardToken = () => {
    return new Promise((resolve) => {
      if (!submitConektaPaymentRef.current) {
        resolve({
          token: '',
          hasError: true,
          error: { message: 'Submit function not ready yet' },
        });
        return;
      }

      // Guardar la función resolve para usarla en los callbacks
      promiseResolveRef.current = resolve;
      promiseRejectRef.current = null;

      // Ejecutar la función de submit de Conekta
      submitConektaPaymentRef.current();
    });
  };

  return {
    requestCardToken,
    token,
    hasError,
    error,
  };
};

